import type { FaireProductEntity } from "../../entity_types/product";

export const p_3zxhmy3eh8: FaireProductEntity = {
  token: "p_3zxhmy3eh8",
  type: "product",
  name: "Mamas Peri Peri Truffle Hot Sauce",
  brandToken: "b_eny6fm9qyb",
  brandName: "Mamas Peri Peri Hot Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/5ddcabeff91a2cbfbb5751d854ffda111e1278c58d7aa0d7f5631ff08038d71b.png",
  galleryImageUrls: [],
  priceDollars: 5.5,
  description:
    "This sauce blends our signature peri peri kick with the earthy, decadent flavor of truffle, creating a taste that is smooth, spicy, and unforgettable!  It is perfect for elevating everything from fries to steaks, it is heat with a touch of class.",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:13.256Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
